import React, {Component, useState, useEffect} from 'react';
import PageContent from "../../../components/page-content/page-content";
import {Button, Card, Col, Row, Space, Table, Tag, Typography} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {getHorses} from "../../../lib/api_horses";
import Horses_add_modal from "./horses_add_modal";
import Horses_edit_modal from "./horses_edit_modal";
import {Link} from "react-router-dom";
import QRModal from "./qr_modal";

const {Column} = Table;
const Horses = () => {
    const [list, setlist] = useState([]);
    const [showHorsesAddModal, setShowHorsesAddModal] = useState(false);
    const [editId, setEditId] = useState(0);
    const [showQRModal, setShowQRModal] = useState(0);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);

    const fetchData = () => {
        getHorses()
            .then((res) => {
                if (res.code === 0) {
                    let data = res.data || [];
                    
                    // 如果有排序字段和顺序，进行本地排序
                    if (sortField && sortOrder) {
                        data.sort((a, b) => {
                            // 首先按是否在厩排序：在厩的排在前面，离厩的排在后面
                            const aInStable = a.in_stable || 0;
                            const bInStable = b.in_stable || 0;
                            
                            if (aInStable !== bInStable) {
                                return bInStable - aInStable; // 1（在厩）排在前面，0（离厩）排在后面
                            }
                            
                            // 然后按指定字段排序
                            const aValue = a[sortField] || '';
                            const bValue = b[sortField] || '';
                            
                            if (sortOrder === 'ascend') {
                                return aValue.localeCompare(bValue, 'zh-CN');
                            } else {
                                return bValue.localeCompare(aValue, 'zh-CN');
                            }
                        });
                    }
                    
                    setlist(data);
                }
            })
    }

    useEffect(fetchData, [sortField, sortOrder]);

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.field && sorter.order) {
            setSortField(sorter.field);
            setSortOrder(sorter.order);
        } else {
            setSortField(null);
            setSortOrder(null);
        }
    };

    return (
        <PageContent title={"马匹管理"}>
            <Card>
                <Row justify="space-between">
                    <Col>

                    </Col>
                    <Col>
                        <Space>
                            <Button type="primary" icon={<PlusOutlined/>}
                                    onClick={() => setShowHorsesAddModal(true)}>添加马匹</Button>
                        </Space>
                    </Col>
                </Row>
                <Table
                    dataSource={list}
                    rowKey={"id"}
                    pagination={false}
                    size={"small"}
                    rowClassName={(record) => (!record.in_stable) || record.in_stable === 0 ? 'row-gray' : ''}
                    onChange={handleTableChange}
                >
                    <Column
                        title="中文名"
                        dataIndex="name"
                        key="中文名"
                        sorter={true}
                    />
                    <Column
                        title="英文名"
                        dataIndex="name_en"
                        key="英文名"
                    />
                    <Column
                        title="权属"
                        dataIndex="quanshu"
                        key="权属"
                        sorter={true}
                    />
                    <Column
                        title="教练"
                        dataIndex="coach_name"
                        key="教练"
                        sorter={true}
                        render={(text, record) => <Link to={`/manage/staff/${record.coach}`}>{text}</Link>}
                    />
                    <Column
                        title="马房"
                        dataIndex="stable_name"
                        key="马房"
                        sorter={true}
                        render={(text, record) => <Link to={`/manage/stables/${record.stable_id}`}>{text}</Link>}
                    />
                    <Column
                        title="重点关注"
                        dataIndex="zdgz"
                        key="重点关注"
                        render={(text, record) => {
                            if (text === 1) {
                                return <Tag color="red">是</Tag>;
                            } else {
                                return <Tag color="blue">否</Tag>;
                            }
                        }}
                    />
                    <Column
                        title="标签"
                        dataIndex="tags"
                        key="标签"
                        render={(text, record) => {
                            if (record.tags) {
                                return JSON.parse(record.tags).map(tag => <Tag color="blue" key={tag}>{tag}</Tag>);
                            } else {
                                return null;
                            }
                        }}
                    />
                    <Column
                        title="二维码"
                        dataIndex="stable_name"
                        key="二维码"
                        render={(value, record, index) => <Typography.Link
                            onClick={() => setShowQRModal(record.id)}>点击查看</Typography.Link>}
                    />
                    <Column
                        title="是否在厩"
                        dataIndex="in_stable"
                        key="是否在厩"
                        render={(text, record) => {
                            if (text === 1) {
                                return "在厩";
                            } else {
                                return "离厩";
                            }
                        }}
                    />

                    <Column
                        title="操作"
                        key="操作"
                        render={
                            (text, record) => (
                                <Link to={`/mafang/horses/${record.id}`}>详情</Link>
                            )
                        }
                    />
                </Table>
            </Card>
            {showHorsesAddModal &&
                <Horses_add_modal
                    onOk={() => {
                        setShowHorsesAddModal(false);
                        fetchData();
                    }}
                    onCancel={() => {
                        setShowHorsesAddModal(false);
                    }}
                />
            }

            {editId > 0 &&
                <Horses_edit_modal
                    id={editId}
                    onOk={() => {
                        setEditId(0);
                        fetchData();
                    }}
                    onCancel={() => {
                        setEditId(0);
                    }}
                />
            }

            {showQRModal > 0 &&
                <QRModal
                    id={showQRModal}
                    onCancel={() => {
                        setShowQRModal(0);
                    }}
                />
            }


        </PageContent>
    );
}

export default Horses;